/**
 * Dekorova — Parametric M² Calculator
 *
 * - Reads configuration from data-* attributes on .dekorova-m2-calc
 * - Performs live area calculation (özel tamlama, asgari m², kapalı kasa)
 * - Validates En/Boy bounds and blocks form submit on invalid values
 * - Injects line-item properties into Dawn's FormData before /cart/add
 */
(function () {
  'use strict';

  document.querySelectorAll('.dekorova-m2-calc').forEach(initCalculator);

  function initCalculator(root) {
    var cfg = {
      sectionId:    root.dataset.sectionId,
      formId:       root.dataset.formId,
      variantPrice: parseInt(root.dataset.variantPrice, 10) || 0,
      minEn:        parseFloat(root.dataset.minEn) || 0,
      maxEn:        parseFloat(root.dataset.maxEn) || 9999,
      minBoy:       parseFloat(root.dataset.minBoy) || 0,
      maxBoy:       parseFloat(root.dataset.maxBoy) || 9999,
      asgariM2:     parseFloat(root.dataset.asgariM2) || 0,
      ozelTamlama:  root.dataset.ozelTamlama === 'true',
      ucretEn:      parseFloat(root.dataset.ucretEn) || 0,
      ucretBoy:     parseFloat(root.dataset.ucretBoy) || 0,
      kapaliKasa:   parseFloat(root.dataset.kapaliKasaUcreti) || 0,
      currency:     root.dataset.currency || '₺'
    };

    // DOM refs
    var elEn       = root.querySelector('.dekorova-m2-calc__en');
    var elBoy      = root.querySelector('.dekorova-m2-calc__boy');
    var elKasa     = root.querySelector('.dekorova-m2-calc__kapali-kasa');
    var elSummary  = root.querySelector('.dekorova-m2-calc__summary');
    var elSumM2    = root.querySelector('.dekorova-m2-calc__summary-m2');
    var elSumUnit  = root.querySelector('.dekorova-m2-calc__summary-unit');
    var elSumKasa  = root.querySelector('.dekorova-m2-calc__summary-kasa');
    var elSumTotal = root.querySelector('.dekorova-m2-calc__summary-total');
    var elKasaRow  = root.querySelector('.dekorova-m2-calc__summary-row--kapali');

    // Error message elements (created dynamically)
    var elEnError  = createErrorEl(elEn);
    var elBoyError = createErrorEl(elBoy);

    // The actual <form> inside <product-form>
    var form = document.getElementById(cfg.formId);
    var productFormEl = form ? form.closest('product-form') : null;

    // State
    var lastCalc = null; // { m2, totalCents, valid }

    // ------------------------------------------------------------------
    //  Variant price tracking
    // ------------------------------------------------------------------
    var productInfo = root.closest('product-info');
    if (productInfo) {
      productInfo.addEventListener('variant:change', function (e) {
        if (e.detail && e.detail.variant && e.detail.variant.price) {
          cfg.variantPrice = e.detail.variant.price;
          calculate();
        }
      });
    }

    if (form) {
      var variantInput = form.querySelector('input.product-variant-id');
      if (variantInput) {
        new MutationObserver(function () {
          var priceEl = productInfo
            ? productInfo.querySelector('.price-item--regular, .price-item--sale')
            : null;
          if (priceEl) {
            var raw = priceEl.textContent.replace(/[^\d.,]/g, '').replace(',', '.');
            var parsed = parseFloat(raw);
            if (!isNaN(parsed)) {
              cfg.variantPrice = Math.round(parsed * 100);
              calculate();
            }
          }
        }).observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      }
    }

    // ------------------------------------------------------------------
    //  Input listeners
    // ------------------------------------------------------------------
    elEn.addEventListener('input', calculate);
    elBoy.addEventListener('input', calculate);
    if (elKasa) elKasa.addEventListener('change', calculate);

    // ------------------------------------------------------------------
    //  Intercept form submit: validate + inject properties
    // ------------------------------------------------------------------
    if (form) {
      // Monkey-patch Dawn's fetch to inject our properties
      var origFetch = window.fetch;
      window.fetch = function (url, options) {
        if (
          typeof url === 'string' &&
          url.indexOf('/cart/add') !== -1 &&
          options && options.body instanceof FormData
        ) {
          // Check if this form submit comes from our product form
          var formDataId = options.body.get('id');
          var ourVariantId = form.querySelector('input.product-variant-id');
          if (ourVariantId && formDataId === ourVariantId.value && lastCalc) {
            // Inject all m2 properties into FormData
            injectProperties(options.body);
          }
        }
        return origFetch.apply(this, arguments);
      };

      // Also add a submit event listener on the form for validation
      form.addEventListener('submit', onFormSubmit, true);
    }

    function onFormSubmit(e) {
      // Run validation
      var result = validate();
      if (!result.valid) {
        e.preventDefault();
        e.stopImmediatePropagation();

        // Show error on Dawn's error wrapper
        if (productFormEl && productFormEl.handleErrorMessage) {
          productFormEl.handleErrorMessage(result.message);
        }
        return false;
      }

      // Make sure calculation is up to date
      calculate();
    }

    function injectProperties(formData) {
      if (!lastCalc || !lastCalc.valid) return;

      // En / Boy
      formData.set('properties[En]', elEn.value + ' cm');
      formData.set('properties[Boy]', elBoy.value + ' cm');
      formData.set('properties[m²]', lastCalc.m2.toFixed(2));
      formData.set('properties[Hesaplanan Fiyat]', formatMoney(lastCalc.totalCents));

      // Kartela
      var kartelaInput = root.querySelector('.dekorova-m2-calc__kartela');
      if (kartelaInput && kartelaInput.value) {
        formData.set('properties[Kartela Kodu]', kartelaInput.value);
      }

      // Zincir
      var zincirChecked = root.querySelector('.dekorova-m2-calc__zincir:checked');
      if (zincirChecked) {
        formData.set('properties[Zincir Yönü]', zincirChecked.value);
      }

      // Kapalı Kasa
      if (elKasa && elKasa.checked) {
        formData.set('properties[Kapalı Kasa]', 'Evet');
      }
    }

    // ------------------------------------------------------------------
    //  Validation
    // ------------------------------------------------------------------
    function validate() {
      clearErrors();

      var enVal  = parseFloat(elEn.value);
      var boyVal = parseFloat(elBoy.value);
      var errors = [];

      if (isNaN(enVal) || enVal === 0) {
        setError(elEn, elEnError, 'En değeri giriniz');
        errors.push('En');
      } else if (enVal < cfg.minEn || enVal > cfg.maxEn) {
        setError(elEn, elEnError, 'En: ' + cfg.minEn + ' – ' + cfg.maxEn + ' cm arası olmalı');
        errors.push('En');
      }

      if (isNaN(boyVal) || boyVal === 0) {
        setError(elBoy, elBoyError, 'Boy değeri giriniz');
        errors.push('Boy');
      } else if (boyVal < cfg.minBoy || boyVal > cfg.maxBoy) {
        setError(elBoy, elBoyError, 'Boy: ' + cfg.minBoy + ' – ' + cfg.maxBoy + ' cm arası olmalı');
        errors.push('Boy');
      }

      // Kartela required check
      var kartelaInput = root.querySelector('.dekorova-m2-calc__kartela');
      if (kartelaInput && kartelaInput.dataset.required === 'true' && !kartelaInput.value.trim()) {
        errors.push('Kartela Kodu');
      }

      // Zincir required check
      var zincirInputs = root.querySelectorAll('.dekorova-m2-calc__zincir');
      if (zincirInputs.length > 0 && zincirInputs[0].dataset.required === 'true') {
        var zincirChecked = root.querySelector('.dekorova-m2-calc__zincir:checked');
        if (!zincirChecked) {
          errors.push('Zincir Yönü');
        }
      }

      if (errors.length > 0) {
        return {
          valid: false,
          message: 'Lütfen gerekli alanları doğru doldurunuz: ' + errors.join(', ')
        };
      }

      return { valid: true };
    }

    function setError(input, errorEl, msg) {
      input.closest('.dekorova-custom-options__input-wrap').classList.add('dekorova-m2-calc__input-error');
      errorEl.textContent = msg;
      errorEl.style.display = 'block';
    }

    function clearErrors() {
      root.querySelectorAll('.dekorova-m2-calc__input-error').forEach(function (el) {
        el.classList.remove('dekorova-m2-calc__input-error');
      });
      elEnError.style.display = 'none';
      elBoyError.style.display = 'none';
      if (productFormEl && productFormEl.handleErrorMessage) {
        productFormEl.handleErrorMessage();
      }
    }

    function createErrorEl(input) {
      var el = document.createElement('span');
      el.className = 'dekorova-m2-calc__error-msg';
      el.style.display = 'none';
      input.closest('.dekorova-custom-options__field').appendChild(el);
      return el;
    }

    // ------------------------------------------------------------------
    //  Calculation
    // ------------------------------------------------------------------
    function calculate() {
      clearErrors();

      var enRaw  = parseFloat(elEn.value);
      var boyRaw = parseFloat(elBoy.value);

      if (isNaN(enRaw) || isNaN(boyRaw) || enRaw <= 0 || boyRaw <= 0) {
        lastCalc = null;
        hideSummary();
        return;
      }

      // Bounds check (visual only during typing)
      var boundsOk = true;
      if (enRaw < cfg.minEn || enRaw > cfg.maxEn) {
        elEn.closest('.dekorova-custom-options__input-wrap').classList.add('dekorova-m2-calc__input-error');
        elEnError.textContent = 'En: ' + cfg.minEn + ' – ' + cfg.maxEn + ' cm';
        elEnError.style.display = 'block';
        boundsOk = false;
      }
      if (boyRaw < cfg.minBoy || boyRaw > cfg.maxBoy) {
        elBoy.closest('.dekorova-custom-options__input-wrap').classList.add('dekorova-m2-calc__input-error');
        elBoyError.textContent = 'Boy: ' + cfg.minBoy + ' – ' + cfg.maxBoy + ' cm';
        elBoyError.style.display = 'block';
        boundsOk = false;
      }
      if (!boundsOk) {
        lastCalc = { valid: false };
        hideSummary();
        return;
      }

      // Özel tamlama
      var hesapEn  = enRaw;
      var hesapBoy = boyRaw;
      if (cfg.ozelTamlama) {
        if (hesapEn < cfg.ucretEn) hesapEn = cfg.ucretEn;
        if (hesapBoy < cfg.ucretBoy) {
          hesapBoy = cfg.ucretBoy;
        } else if (hesapBoy > cfg.ucretBoy) {
          hesapBoy = Math.ceil(hesapBoy / 10) * 10;
        }
      }

      // M²
      var m2 = (hesapEn / 100) * (hesapBoy / 100);
      if (cfg.asgariM2 > 0 && m2 < cfg.asgariM2) {
        m2 = cfg.asgariM2;
      }
      m2 = Math.round(m2 * 100) / 100;

      // Price
      var unitPriceCents = cfg.variantPrice;
      var areaCost = m2 * unitPriceCents;
      var kasaCost = 0;
      if (elKasa && elKasa.checked) {
        kasaCost = cfg.kapaliKasa * 100;
      }
      var totalCents = areaCost + kasaCost;

      // Store state
      lastCalc = { m2: m2, totalCents: totalCents, valid: true };

      // Update summary
      elSummary.style.display = '';
      elSumM2.textContent = m2.toFixed(2) + ' m²';
      elSumUnit.textContent = formatMoney(unitPriceCents) + ' / m²';
      elSumTotal.textContent = formatMoney(totalCents);

      if (elKasaRow) {
        if (elKasa && elKasa.checked) {
          elKasaRow.style.display = '';
          elSumKasa.textContent = '+' + formatMoney(kasaCost);
        } else {
          elKasaRow.style.display = 'none';
        }
      }
    }

    function hideSummary() {
      elSummary.style.display = 'none';
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return intPart + ',' + parts[1] + ' ' + cfg.currency;
    }
  }
})();
